import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "textStyle", "fontSize", "fontWeight", "lineHeight", "letterSpacing", "fontFamily", "textTransform", "badgeLegacyTypography", "badgeSemanticTypography"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Badge as ChakraBadge } from '@chakra-ui/react';
import { useSemanticTypography } from '@whitbread-eos/utils';
import { semanticTextStyles } from '../../theme/adapters/semanticTypography';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultBadgeSemanticTypography = {
  textStyle: 'label-s'
};
export default function Badge(_ref) {
  var _semanticTextStyles;
  var variant = _ref.variant,
    textStyle = _ref.textStyle,
    fontSize = _ref.fontSize,
    fontWeight = _ref.fontWeight,
    lineHeight = _ref.lineHeight,
    letterSpacing = _ref.letterSpacing,
    fontFamily = _ref.fontFamily,
    textTransform = _ref.textTransform,
    badgeLegacyTypography = _ref.badgeLegacyTypography,
    badgeSemanticTypography = _ref.badgeSemanticTypography,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var getTypographyProps = useSemanticTypography();
  var badgeInlineLegacyTypography = {
    fontSize,
    fontWeight,
    lineHeight,
    letterSpacing,
    fontFamily,
    textTransform
  };
  var resolvedBadgeLegacyTypography = badgeLegacyTypography !== null && badgeLegacyTypography !== void 0 ? badgeLegacyTypography : badgeInlineLegacyTypography;
  var resolvedBadgeSemanticTypography = badgeSemanticTypography !== null && badgeSemanticTypography !== void 0 ? badgeSemanticTypography : textStyle ? {
    textStyle
  } : defaultBadgeSemanticTypography;
  var typographyProps = getTypographyProps(resolvedBadgeLegacyTypography, resolvedBadgeSemanticTypography);
  var isSemanticMode = 'textStyle' in typographyProps;
  var resolvedTypographyStyles = isSemanticMode ? (_semanticTextStyles = semanticTextStyles[typographyProps.textStyle]) !== null && _semanticTextStyles !== void 0 ? _semanticTextStyles : {} : typographyProps;
  if (variant === 'ZIP') {
    return _jsx(ChakraBadge, _objectSpread(_objectSpread(_objectSpread({
      variant: "ZIP"
    }, otherProps), resolvedTypographyStyles), {}, {
      children: "ZIP"
    }));
  }
  if (variant === 'hub') {
    return _jsx(ChakraBadge, _objectSpread(_objectSpread(_objectSpread({
      variant: "hub"
    }, otherProps), resolvedTypographyStyles), {}, {
      children: "hub"
    }));
  }
  return _jsx(ChakraBadge, _objectSpread(_objectSpread({
    variant: variant
  }, otherProps), resolvedTypographyStyles));
}